import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    Button,
    Typography,
    Box,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link as MuiLink } from "@mui/material";
import UsageBox from "./UsageBox";
import PricesSection from "../PricesSection";
import ContactForm from "../ContactForm";

const UpgradeDialog = ({ open, onClose, userId, styles, user, theme }) => {
    const [showContact, setShowContact] = useState(false);

    const handleContactClick = (e) => {
        e.preventDefault();
        setShowContact(true);
    };

    const handleBackClick = () => {
        setShowContact(false);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    maxWidth: 1300,
                    height: {
                        xs: 500, // Mobile
                        sm: 600, // Tablet
                        md: 800, // Desktop
                    },
                    position: "relative",
                },
            }}
        >
            <DialogTitle
                sx={{
                    p: 3,
                    pb: 2,
                    position: "relative",
                }}
            >
                <Box
                    sx={{
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                    }}
                >
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{
                            fontWeight: 700,
                            fontSize: "2rem",
                            textAlign: "center",
                            backgroundClip: "text",
                            textFillColor: "transparent",
                            background:
                                "linear-gradient(135deg, #43CBFF 10%, #9708CC 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        {showContact ? "Kontakta oss" : "Uppgradera ditt konto"}
                    </Typography>
                </Box>
                {!showContact && (
                    <Box>
                        <Typography
                            variant="body1"
                            gutterBottom
                            sx={{
                                textAlign: "center",
                                fontWeight: "600",
                                mt: 1,
                                mb: 0,
                            }}
                        >
                            <MuiLink
                                onClick={handleContactClick}
                                sx={{
                                    color: "text.secondary",
                                    textDecoration: "none",
                                    paddingBottom: "0px",
                                    borderBottom: "2px solid",
                                    borderColor: "text.secondary",
                                    cursor: "pointer",
                                    "&:hover": {
                                        textDecoration: "none",
                                        borderColor: "text.primary",
                                    },
                                }}
                            >
                                Kontakta oss
                            </MuiLink>
                        </Typography>
                    </Box>
                )}
                {/* Back button when showing contact form */}
                {showContact && (
                    <IconButton
                        onClick={handleBackClick}
                        size="large"
                        sx={{
                            position: "absolute",
                            left: 20,
                            top: 20,
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: "30px" }} />
                    </IconButton>
                )}

                {/* Close button */}
                <IconButton
                    onClick={onClose}
                    size="large"
                    sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent sx={{ p: 0, pt: 3 }}>
                {showContact ? (
                    <ContactForm bgcolor="transparent" />
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                            mb: 4,
                            mt: 2,
                        }}
                    >
                        <Box sx={{ width: "100%", mt: -2 }}>
                            <PricesSection
                                hideBasic={false}
                                strikeThrough={true}
                                user={user}
                                styles={styles}
                            />
                        </Box>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default UpgradeDialog;
